<div class="pt-8 flex align-middle items-center">
    <div class="w-1/2">
        <h4 class="font-bold">{{heading}}</h4>
        <p class="text-sm pt-1">{{help}}</p>
    </div>
    <div class="mx-4">
        <app-toggle-switch [(checked)]="value" (checkedChange)="toggleChanged()"></app-toggle-switch>        
    </div>
</div>